import { $post, filterResponse } from '@/request/methods'

export function getUserInfo() {
  return $post('/user/info').then(filterResponse)
}

export function getAppConfig() {
  return $post('/config/front/all').then(filterResponse)
}


// 根据用户ID获取用户详情
export function usersDetailListByIds(data) {
  return $post('/perf/surface/AssessProject/user/Details/userListByIds', data).then(filterResponse)
}
// 获取部门列表
export function getDepartmentListForCache(data) {
  if (!data) { data = '{}' }
  return $post('/perf/surface/AssessProject/department/list', data).then(filterResponse)
}

// 绑定飞书登录
export function bindFeishuLogin(data) {
  return $post('/feishu/login/bind', data).then(filterResponse)
}

// 校验邀请码
export function wechatLoginVerify(data) {
  return $post('/wechat/login/verify', data).then((res) => filterResponse(res, { catchDataReturn: true, showErrorMsg: false }))
}